module.exports = __webpack_public_path__ + "img/Business.d9c7e9ee.png";